// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2R4fp","alertIcon":"ConfirmModal_alertIcon__15jdE"};